import { groupAvailabilitiesByDay } from '@/lib/coach-availability-utils';
import { formatPlainTime, FrequentTimeZones } from '@airreading/common';
import { CoachAvailability, DayOfWeek, DayOfWeekLabelMap, teachingDays } from '@airreading/common/data';

export const TeacherAvailabilityTable = ({
  teacherAvailabilities,
  teacherName,
}: {
  teacherAvailabilities: CoachAvailability[];
  teacherName: string;
}) => {
  const { availabilitiesByDay } = groupAvailabilitiesByDay(teacherAvailabilities, FrequentTimeZones.UsCentral);

  return (
    <>
      <div className="flex items-center gap-2 justify-start mb-2">
        <p className="font-semibold text-lg">{teacherName}</p>
      </div>
      <div className="rounded-md border border-gray-200">
        <div className="grid grid-cols-7 divide-x divide-gray-200">
          {teachingDays.map((day: DayOfWeek) => {
            const dayAvailabilities = availabilitiesByDay.find((d) => d.day === day)?.availabilities ?? [];

            return (
              <div key={day} className="p-3">
                <div className="font-semibold -mx-3 px-3 pb-2 mb-2 border-b border-gray-200 text-base">
                  {DayOfWeekLabelMap[day].abbr}
                </div>
                {dayAvailabilities.length === 0 ? (
                  <div className="text-sm">-</div>
                ) : (
                  dayAvailabilities.map((availability, index) => {
                    const start = formatPlainTime(availability.startPlainTime, { hour12: true });
                    const end = formatPlainTime(availability.endPlainTime, { hour12: true });
                    const isLast = index === dayAvailabilities.length - 1;
                    return (
                      <div key={`${day}-${index}`} className="text-sm">{`${start} - ${end}${isLast ? '' : ','}`}</div>
                    );
                  })
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
